import { PROGRESS } from "../types/actions";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case PROGRESS.GET_PROGRESS_CHARTS:
            return { ...state, ...action.payload };
        case PROGRESS.GET_PROGRESS_WEIGHT_HISTORY_LIST:
            return { ...state, weight_history_list: action.payload };
        case PROGRESS.GET_PROGRESS_MEMBERWEIGHT_HISTORY_LIST:
            return { ...state, memberweight_history_list: action.payload };
        case PROGRESS.POST_ADD_WEIGHT:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
